import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import styles from "./MaterialTruckDetails.module.scss";
import MaterialDetails from "./MaterialDetails";
import TruckDetails from "./TruckDetails";
import { useTruckMaterialFormFlowContext } from "../../../../context/TruckMaterialFormFlowContext";
import { AddTruckType } from "../../../../enums/AddTruckType";
import { tabHeader } from "./constants";

const MaterialTruckDetails = ({
  leadId,
  isEditable,
  dropOffLatLng,
  dropOff,
}: {
  leadId?: string;
  isEditable?: boolean;
}) => {
  const { TabPane } = Tabs;
  const { truck, materail } = tabHeader;
  const { truckFormType, setTruckFormType } = useTruckMaterialFormFlowContext();
  const handleFlowType = (key: string) => {
    if (key === "1") {
      setTruckFormType(String(AddTruckType.MATERIAL_VENDOR_FLOW));
    } else if (key === "2") {
      setTruckFormType(String(AddTruckType.TRUCK_ADD_FLOW));
    }
  };
  return (
    <div className={styles.MaterialTruckDetailsContainer}>
      <Tabs
        swipeable
        size="16px"
        type="line"
        tabPosition="top"
        defaultActiveKey="1"
        onChange={handleFlowType}
      >
        <TabPane tab={materail} key="1">
          <MaterialDetails
            isEditable={isEditable}
            dropOffLatLng={dropOffLatLng}
            dropOff={dropOff}
          />
        </TabPane>
        <TabPane tab={truck} key="2">
          <TruckDetails
            leadId={leadId}
            isEditable={isEditable}
            dropOffLatLng={dropOffLatLng}
            dropOff={dropOff}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default MaterialTruckDetails;
